export async function initialize() {
    if (!global.Intl) {
        await import('intl');

        // the locales must be loaded _after_ the main polyfill
        await Promise.all([
            import('intl/locale-data/jsonp/en'),
            // import('intl/locale-data/jsonp/es'),
        ]);
    }
}
